<!-- =========================================================================================
  File Name: TabInformation.vue
  Description: Partner Edit Information Tab content
========================================================================================== -->

<template>
  <div id="tab-information">

    <!-- Logo Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <!-- <img :src="partner.logo" class="mr-8 rounded h-24 w-24" /> -->
          <img :src="'/img/avatar-s-3.7ed1da4a.jpg'" class="mr-8 rounded h-24 w-24" />
          <!-- <vs-avatar :src="partner.avatar" size="80px" class="mr-4" /> -->
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ partnerLocal.company  }}</p>
            <input type="file" class="hidden" ref="update_logo_input" @change="update_logo" accept="image/*">

            <vs-button class="mr-4" type="border" color="success" @click="$refs.update_logo_input.click()">Изменить логотип</vs-button>

            <vs-button type="border" color="danger">Удалить логотип</vs-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Название компании" v-model="partnerLocal.company" v-validate="'required'" name="company" />
        <span class="text-danger text-sm"  v-show="errors.has('company')">{{ errors.first('company') }}</span>

        <div class="mt-4">
          <label class="vs-input--label">Программа</label>
          <v-select v-model="program_local" :clearable="false" :options="programsOptions()" v-validate="'required'" name="program" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('program')">{{ errors.first('program') }}</span>
        </div>

        <div class="mt-4">
          <label class="vs-input--label">Статус</label>
          <v-select v-model="status_local" :clearable="false" :options="statusOptions" v-validate="'required'" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('status')">{{ errors.first('status') }}</span>
        </div>

      </div>

      <div class="vx-col md:w-1/2 w-full">

        <vs-input class="w-full mt-4" label="Имя" v-model="partnerLocal.fname" v-validate="'required'" name="fname" />
        <span class="text-danger text-sm"  v-show="errors.has('fname')">{{ errors.first('fname') }}</span>

        <vs-input class="w-full mt-4" label="Фамилия" v-model="partnerLocal.lname" v-validate="'required'" name="lname" />
        <span class="text-danger text-sm"  v-show="errors.has('lname')">{{ errors.first('lname') }}</span>

        <vs-input class="w-full mt-4" label="Должность" v-model="partnerLocal.position" v-validate="'required'" name="position" />
        <span class="text-danger text-sm"  v-show="errors.has('position')">{{ errors.first('position') }}</span>

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" icon-pack="feather" icon="icon-chevron-left" :to="{ name: 'apps-partners-view', params:{ partnerId: $route.params.partnerId } }">Назад</vs-button>
          <vs-button class="ml-4 mt-2" icon-pack="feather" icon="icon-rotate-cw" type="border" color="warning" @click="reset_partner">Сброс</vs-button>
          <vs-button class="ml-4 mt-2" icon-pack="feather" icon="icon-save" color="success" @click="save_changes" :disabled="!validateForm">Сохранить</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modulePartner from '@/store/partner/modulePartner.js'
import vSelect from 'vue-select'

// Биндинг работает только так и никак иначе, нужно это понимать

export default {
  components: {
    vSelect
  },
  data() {
    return {
      partnerLocal: Object.assign({}, this.$store.getters["partner/getPartner"]),
      partnerOriginal: Object.assign({}, this.$store.state.partner.partner),
      statusOptions: modulePartner.partnerStateList,
    }
  },
  computed: {
    programs() {
      return this.$store.state.partner.programs
    },
    status_local: {
      get() {
        return { label: modulePartner.partnerStateList[this.partnerLocal.state].label,  value: this.partnerLocal.state  }
      },
      set(obj) {
        // this.$store.commit("partner/UPDATE_PARTNER_STATE", obj.value)
        this.partnerLocal.state = obj.value
      }
    },
    program_local: {
      get() {
        if (!this.programs.length) return {label: '', value: ''}
        let index = this.programs.findIndex((t) => t.ppid == this.partnerLocal.program)
        if (index === -1) index = 0
        return { label: this.programs[index].name,  value: this.programs[index].ppid  }
      },
      set(obj) {
        // this.$store.commit("partner/UPDATE_PARTNER_PROGRAM", obj.value)
        this.partnerLocal.program = obj.value
      }
    },
    validateForm() {
      return !this.errors.any() && this.partnerLocal.company && this.partnerLocal.phone
    }
  },
  methods: {
    programsOptions() {
      let options = []
      this.programs.forEach(prog => {
        options.push({ label: prog.name, value: prog.ppid })
      })
      return options
    },
    save_changes() {
      if(!this.validateForm) return

      this.$store.dispatch("partner/updatePartner", this.partnerLocal)
      .then(() => {
        // this.$router.push({ name:'apps-partners-view', params: { partnerId: this.partnerLocal.partid } });
      })

    },
    reset_partner() {
      this.partnerLocal = Object.assign({}, this.partnerOriginal)
    },
    update_logo() {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    }
  },
}
</script>
